import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { adobeCjaEventEmitter } from '../../../../../../modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_CATEGORIES, LINK_SECTION, LINK_NAMES, LINK_TYPES } from '../../../../../../modules/adobe-cja/constants'

export default {
  props: {
    hasAgreementsPermission: {
      type: Boolean,
      required: false
    },
    contractType: {
      type: String,
      required: false
    }
  },

  setup(props) {
    const router = useRouter()

    const contractSummary = computed(() => { return props.contractType })
    const agrrementsPermission = computed(() => props.hasAgreementsPermission ? 'hasPermission' : 'hasNoPermission')
    const gotoAgreementsIconClass = computed(() => `${props.hasAgreementsPermission ? '' : 'white-'}lock-icon`)

    const contractSummaryTypeTitle = computed(() => {
      const contractTypes = ['UFDA', 'Monotype IP', '', 'MyFonts', 'Multiple Other', 'Dual Legacy', 'No Contract', 'Type Designer', 'Monotype Third Party'];
      return contractTypes.includes(contractSummary.value)
    })

    const contractSummaryTypeDesc = computed(() => {
      const contractTypes = ['Monotype IP', '', 'MyFonts', 'Multiple Other', 'Dual Legacy', 'No Contract', 'Type Designer', 'Monotype Third Party'];
      return contractTypes.includes(contractSummary.value)
    })

    const gotoAgreements = () => {
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.SIGN_LATEST_AGREEMENT,
          linkSection: LINK_SECTION.DASHBOARD,
          linkName: LINK_NAMES.SIGN_LATEST_AGREEMENT,
          linkType: LINK_TYPES.BUTTON
        }
      })
      router.push({ name: 'contract' })
    }

    return {
      contractSummary,
      contractSummaryTypeTitle,
      contractSummaryTypeDesc,
      agrrementsPermission,
      gotoAgreementsIconClass,
      gotoAgreements
    }
  }
}
